import Flickity from 'flickity-imagesloaded'
import * as modal from './modal'
const jQueryBridget = require('jquery-bridget')

// make Flickity a jQuery plugin
jQueryBridget('flickity', Flickity, $)

const EVENTS = {
  FLICKITY_CLICK: 'staticClick.flickity',
}

const SELECTORS = {
  BASES: 'html, body',
  SLIDE: '[data-slide-id]',
}

const sliderOptions = {
  contain: true,
  cellAlign: 'left',
  imagesLoaded: true,
  pageDots: false,
  percentPosition: false,
  prevNextButtons: false,
  autoPlay: 1500,
  pauseAutoPlayOnHover: false,
}

const $slider = $('[data-slider]').flickity(sliderOptions)
const SLIDER_MODAL_ACTIVE_CLASS = 'slider-modal--is-active'

export default () => {

  $(window).on('load', function() {
    modal.init()
  })

  $slider.on(EVENTS.FLICKITY_CLICK, function(event, pointer, cellElement) {
    if (!cellElement) {
      return
    }

    const id = cellElement.getAttribute('data-slide-id')
    modal.open(id)
  })

  $(document).on('modal:open', (event, data) => {
    $(`[data-modal-id=${data.id}]`).addClass(SLIDER_MODAL_ACTIVE_CLASS)
  })

  $(document).on('modal:close', (event, data) => {
    $(`[data-modal-id=${data.id}]`).removeClass(SLIDER_MODAL_ACTIVE_CLASS)
  })

}



// WEBPACK FOOTER //
// ./slider.js